import { message } from "antd";
import { Store } from "../src/redux/store/store";
import { _authenticateUser } from "./redux/actions/authAction";
import moment from "moment";
import ValidatedAge from "./dentail-indetifcation/components/validated-age/ValidatedAge";
import dayjs from "dayjs";
import isBetween from "dayjs/plugin/isBetween";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";

import {
  CheckCircleOutlined,
  ExclamationCircleOutlined,
  SearchOutlined,
  CloseCircleOutlined,
  QuestionCircleOutlined,
} from "@ant-design/icons";

// Extend dayjs with the necessary plugins
dayjs.extend(isBetween);
dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);

export const errorRequestHandel = ({ error }) => {
  if (error?.response?.status === 422) {
    const err = error.response.data.errors;
    message.error(err[Object.keys(err)[0]]);
  } else if (error?.response?.status === 400) {
    message.error(
      error?.response?.data?.message ?? error?.response?.data?.error
    );
  } else if (error?.response?.status === 401) {
    localStorage.removeItem("user");
    Store.dispatch(_authenticateUser(false));
    message.error(error?.response?.data?.message);
    // window.location.href = '/';
  } else if (error?.response?.status === undefined) {
    message.error("Server down temporarily");
  } else {
    message.error(
      error?.response?.data?.message ?? error?.response?.data?.error
    );
  }
  return null;
};

export const appendFormData = (fileTitle, file, data = {}) => {
  var formData = new FormData();
  if (file !== null) {
    formData.append(fileTitle, file);
    Object.keys(data).forEach((key) => {
      formData.append(key, data[key]);
    });
    return formData;
  }
};

export const getImageDimensions = (file) => {
  var _URL = window.URL || window.webkitURL;
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () =>
      resolve({
        width: img.width,
        height: img.height,
      });
    img.onerror = (error) => reject(error);
    img.src = _URL.createObjectURL(file);
  });
};

export const isValidEmailAddress = (email) => {
  let pattern =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return pattern.test(String(email).toLowerCase());
};

export const validatePassword = (password) => {
  var p = password,
    errors = [];
  if (p.length < 8) {
    errors.push("Password must be 8 charactor long");
  }
  if (p.search(/[a-z]/i) < 0) {
    errors.push("Your password must contain one letter");
  }
  if (p.search(/[0-9]/) < 0) {
    errors.push("Your password must contain one digit");
  }
  return errors;
};

export function findPlanValuesWithType(arr, type) {
  // Iterate over the input array
  for (let i = 0; i < arr.length; i++) {
    // Check if the current item's type is "free"
    if (arr[i].slug === type) {
      // If it is, return the value of the current item
      return arr[i];
    }
  }

  // If no element of type "free" is found, return null or undefined
  return null; // or undefined
}

export const dentalBasePath = "/dental-identification";
export const ageAssessmentBasePath = "/age-assessment";

export const findCreatedBy = (data, userId) => {
  return data?.find((el) => el.id === userId);
};

export const formateDateAndTime = (date, formate = "DD-MM-YYYY") => {
  const momentDate = moment(date);
  return momentDate.isValid() ? momentDate.format(formate) : "-";
};

export const toTitleCase = (str) => {
  if (!str) return "";
  return str
    .toLowerCase()
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

export const ownerShipData = [
  {
    id: 1,
    title: "All",
    value: "",
  },
  {
    id: 1,
    title: "Owned by me",
    value: "me",
  },
  {
    id: 2,
    title: "Collaboration",
    value: "collaboration",
  },
];
export const projectStatuses = [
  {
    id: 1,
    title: "Active",
    value: "open",
  },
  {
    id: 3,
    title: "Archived",
    value: "archived",
  },
  {
    id: 3,
    title: "Completed",
    value: "completed",
  },
];

export const countForGenderAndProgress = (cases) => {
  let result = {
    pm: { male: 0, female: 0, unknown: 0 },
    am: { male: 0, female: 0, unknown: 0 },
  };

  cases.forEach((caseItem) => {
    const { gender, case_type } = caseItem;

    // Ensure case_type is either 'pm' or 'am'
    if (case_type === "pm") {
      if (gender === "Male") {
        result.pm.male++;
      } else if (gender === "Female") {
        result.pm.female++;
      } else {
        result.pm.unknown++;
      }
    } else if (case_type === "am") {
      if (gender === "Male") {
        result.am.male++;
      } else if (gender === "Female") {
        result.am.female++;
      } else {
        result.am.unknown++;
      }
    }
  });

  return result;
};

export const filterAmCaseAddedByACollaborator = (
  cases,
  collaboratorId,
  caseType
) => {
  const count = cases.filter(
    (item) => item.addedBy?.id === collaboratorId && item.case_type === caseType
  )?.length;
  return count > 0 ? count : "-";
};

export const filterPmCaseAddedByACollaborator = (
  cases,
  collaboratorId,
  caseType
) => {
  const count = cases.filter(
    (item) => item.addedBy?.id === collaboratorId && item.case_type === caseType
  )?.length;
  return count > 0 ? count : "-";
};

export const amDentalRecordAddedCount = (cases) => {
  const count = cases.reduce((count, item) => {
    if (item.case_type === "am" && item.records && item.records.length > 0) {
      count += 1; // Increment count if the case matches the type and has records
    }
    return count;
  }, 0); // Start count at 0
  return count === 0 ? "-" : count; // Return "-" if count is 0, otherwise return count
};
export const pmDentalRecordAddedCount = (cases) => {
  const count = cases.reduce((count, item) => {
    if (item.case_type === "pm" && item.records && item.records.length > 0) {
      count += 1; // Increment count if the case matches the type and has records
    }
    return count;
  }, 0); // Start count at 0
  return count === 0 ? "-" : count; // Return "-" if count is 0, otherwise return count
};

// export const renderToothConditionColors = (type) => {
//   if (type === "missing") {
//     return "#DA6A6D";
//   } else if (type === "restored") {
//     return "#49B2DE";
//   } else if (type === "present") {
//     return "#E29365";
//   } else if (type === "landmark") {
//     return "#9765B6";
//   } else if (type === "decayed") {
//     return "#7A3E10";
//   }
// };
export const renderToothConditionColors = (type) => {
  if (type === "missing") {
    return "#E53935"; // Red - Missing tooth
  } else if (type === "restored") {
    return "#1E5BDB"; // Blue - Restored tooth
  } else if (type === "present") {
    return "#FB6A0A"; // Orange - Present tooth
  } else if (type === "decayed") {
    return "#7A3E10"; // Brown - Decayed tooth
  } else if (type === "noinfo") {
    return "#9DA3AD"; // Gray - No information
  } else if (type === "landmark") {
    return "#007C7A"; // Teal - Dental Landmark
  }
};

export const removeQuadrantPrefix = (name) => {
  return name.replace(/^(Upper|Lower) (Left|Right) /, "");
};

export const transformServerDataToMarkedTeeth = (serverData) => {
  return serverData
    .filter((record) => record.type !== "quadrant") // Exclude quadrant records
    .map((record) => {
      // Extract first condition if available

      // Remove duplicates based on condition_id
      const uniqueConditions = [];
      record.conditions.forEach((condition) => {
        // Check if the condition_id already exists in the uniqueConditions array
        if (
          !uniqueConditions.some(
            (item) => item.parentCondition?.id === condition.parentCondition?.id
          )
        ) {
          uniqueConditions.push(condition);
        }
      });

      return {
        id: record.tooth_id,
        tooth_id: record.tooth_id || "", // Set empty string for non-tooth records
        conditions: uniqueConditions.map((c) => ({
          condition_id: c.parentCondition?.id,
          condition_type: c.parentCondition.condition_type,
          condition_identifier: c.parentCondition?.identifier || "",
          condition_icon: "", // No icon data in server response
        })),
        subConditions: record.conditions.map((c) => ({
          condition_id: c.condition.id,
          serial_number: c.serial_number,
          surfaces: c.surfaces || [],
        })),
        observation: record.observation || "",
        marked_completed: record?.conditions.length > 0 ? true : false, // Set true by default
      };
    });
};

export const transformQuadrantData = (serverData) => {
  return serverData
    .filter((record) => record.type === "quadrant") // Only process quadrant records
    .map((record) => {
      const conditions = [];
      const subConditions = [];

      record.conditions.forEach((c) => {
        if (c.parentCondition) {
          // Add parentCondition ID to conditions if not already present
          if (
            !conditions.some(
              (cond) => cond.condition_id === c.parentCondition.id
            )
          ) {
            conditions.push({
              condition_id: c.parentCondition.id,
              condition_type: c.parentCondition?.condition_type,
              condition_identifier: c.parentCondition?.identifier,
              surfaces: c.surfaces || [], // Ensure surfaces array
            });
          }
        }

        // Add condition ID to subConditions
        subConditions.push(c.condition.id);
      });

      return {
        identifier: record.quadrant || "", // Use quadrant value or empty string
        quadrant: record.quadrant, // Always empty as per your format
        conditions: conditions, // Only parentCondition ID and surfaces
        observation: record.observation || "",
        marked_completed: true, // Default to false
        subConditions: subConditions, // Only condition IDs
      };
    });
};

export function normalizeSubscription(activeSubscription) {
  const now = dayjs();

  if (!activeSubscription) {
    return {
      id: null,
      type: null,
      status: null,
      isActive: false,
      isExpired: false,
      isCancelled: false,
      noOfSeats: null,
      startDate: null,
      endDate: null,
      cancellationDate: null,
    };
  }

  const startAt = dayjs(activeSubscription.start_at);
  const endAt = dayjs(activeSubscription.end_at);
  const canceledAt = activeSubscription.canceled_at
    ? dayjs(activeSubscription.canceled_at)
    : null;

  let status = "unknown";
  let isCancelled = false;
  let isActive = false;
  let isExpired = false;
  let isPending = false;

  // 1. Check if cancelled: This takes precedence
  if (activeSubscription.canceled_at !== "") {
    isCancelled = true;
    status = "cancelled";
  }

  // 2. Determine active, expired, or pending if not cancelled
  if (!isCancelled) {
    if (now.isBetween(startAt, endAt, null, "[]")) {
      isActive = true;
      status = "active";
    } else if (now.isBefore(startAt)) {
      isPending = true;
      status = "pending";
    } else if (now.isAfter(endAt)) {
      isExpired = true;
      status = "expired";
    }
  }

  // Determine normalized type
  let normalizedType;
  if (activeSubscription.type === "trial") {
    normalizedType = "trial";
  } else if (activeSubscription.type === "free") {
    normalizedType = "free";
  } else if (activeSubscription.interval === "month") {
    normalizedType = "monthly";
  } else if (activeSubscription.interval === "year") {
    normalizedType = "yearly";
  } else {
    normalizedType = "unknown";
  }
  console.log("activeSubscription", activeSubscription);

  return {
    id: activeSubscription.id,
    type: normalizedType,
    status: status,
    isActive: isActive,
    isExpired: isExpired,
    isCancelled: isCancelled,
    noOfSeats: activeSubscription.no_of_seats,
    startDate: startAt.isValid() ? startAt.format("YYYY-MM-DD") : null,
    endDate: endAt.isValid() ? endAt.format("YYYY-MM-DD") : null,
    cancellationDate:
      canceledAt && canceledAt.isValid()
        ? canceledAt.format("YYYY-MM-DD")
        : null,
  };
}

export const filterAmPmDentalRecordAddedByCollaborator = (
  collaboratorId,
  caseType,
  cases
) => {
  const count = cases.reduce((total, item) => {
    if (
      item.case_type === caseType && // Check if case type is "am"
      item.records && // Ensure records exist
      item.records.some((record) => record.added_by === collaboratorId) // Check if the collaborator added any record
    ) {
      total += 1; // Increment count for each matching case
    }
    return total;
  }, 0);

  return count === 0 ? "-" : count; // Return "-" if no matching records, else return count
};

export const renderToothConditionBgColors = (type) => {
  if (type === "missing") {
    return "#DA6A6D1F";
  } else if (type === "restored") {
    return "#49B2DE";
  } else if (type === "present") {
    return "#E29365";
  } else if (type === "landmark") {
    return "#9765B669";
  }
};

export const renderProjectStatusTextAndBgColor = (status) => {
  const statusColors = {
    open: "#34A853",
    archived: "#9E9E9E",
    completed: "#4C94F6",
    closed: "#DC191942",
  };
  return statusColors[status] || statusColors.default;
};
export const renderCaseStatusTextAndBgColor = (status) => {
  const statusColors = {
    new: "#FFB44F",
    completed: "#00B366",
    in_progress: "#9E9E9E",
    submitted: "#9E9E9E",
  };
  return statusColors[status] || statusColors.default;
};

export const getInitials = (fullName) => {
  const nameParts = fullName.split(" "); // Split the full name by space
  if (nameParts.length < 2) {
    return nameParts[0].charAt(0).toUpperCase(); // If there's no last name, return the first letter of the first name
  }
  const firstNameInitial = nameParts[0].charAt(0).toUpperCase(); // First letter of the first name
  const lastNameInitial = nameParts[1].charAt(0).toUpperCase(); // First letter of the last name
  return firstNameInitial + lastNameInitial; // Concatenate initials
};

export const getPendingRecords = (project) => {
  if (!project || !project.cases) {
    // Return 0 if project is null or cases are not available
    return {
      amPendingRecordCount: 0,
      pmPendingRecordCount: 0,
    };
  }

  // Count pending AM cases (cases with 'am' type and no records)
  const amPendingRecordCount = project.cases.filter(
    (c) => c.case_type === "am" && c.records.length === 0
  ).length;

  // Count pending PM cases (cases with 'pm' type and no records)
  const pmPendingRecordCount = project.cases.filter(
    (c) => c.case_type === "pm" && c.records.length === 0
  ).length;

  return {
    amPendingRecordCount,
    pmPendingRecordCount,
  };
};

export const _quadrants = [
  {
    id: 1,
    value: "ur",
    title: "Upper Right Quadrant (UR - Q1)",
  },
  {
    id: 2,
    value: "ul",
    title: "Upper Left Quadrant (UL - Q2)",
  },
  {
    id: 3,
    value: "lr",
    title: "Lower Right Quadrant (LR - Q4)",
  },
  {
    id: 4,
    value: "ul",
    title: "Upper Left Quadrant (LL - Q3)",
  },
];

export const capitalizeStatus = (status) =>
  status !== "N/A"
    ? status.charAt(0).toUpperCase() + status.slice(1).toLowerCase()
    : status;

export const getChildToothISO = (toothNumber) => {
  // Mapping child tooth numbers to ISO
  const toothMap = {
    // Upper Right (Quadrant 5)
    15: "55",
    14: "54",
    13: "53",
    12: "52",
    11: "51",
    // Upper Left (Quadrant 6)
    21: "61",
    22: "62",
    23: "63",
    24: "64",
    25: "65",
    // Lower Left (Quadrant 7)
    31: "71",
    32: "72",
    33: "73",
    34: "74",
    35: "75",
    // Lower Right (Quadrant 8)
    41: "81",
    42: "82",
    43: "83",
    44: "84",
    45: "85",
  };

  // Return the corresponding ISO or empty string for invalid tooth numbers
  return toothMap[toothNumber] || "";
};

export const checkIfAllTeethHaveSameType = (tempTeeth, metaData) => {
  // Filter the teeth based on the tempTeeth IDs
  const filteredTeeth = metaData.teeth.filter((tooth) =>
    tempTeeth.includes(tooth.id)
  );

  // If no teeth are found, return false
  if (filteredTeeth.length === 0) {
    return false;
  }

  // Check if the first tooth has a 'type'
  const firstConditionType = filteredTeeth[0]?.type;

  // If no condition_type is found in the first tooth, return false
  if (!firstConditionType) {
    return false;
  }

  // Compare type of all filtered teeth
  const allSameType = filteredTeeth.every(
    (tooth) => tooth.type === firstConditionType
  );
  return !allSameType;
};

export const findTeethType = (tempTeeth, metaData) => {
  if (!tempTeeth || tempTeeth.length === 0) return null; // No teeth selected

  // Extract the type of the first tooth
  const firstToothType = metaData?.teeth?.find(
    (tooth) => tooth.id === tempTeeth[0]
  )?.type;

  if (!firstToothType) return null; // Type not found for the first tooth

  // Check if all selected teeth have the same type
  const allSameType = tempTeeth.every((toothId) => {
    const toothType = metaData?.teeth?.find(
      (tooth) => tooth.id === toothId
    )?.type;
    return toothType === firstToothType;
  });

  return allSameType ? firstToothType : null; // Return type if all match, else null
};

export const transFormTeethAndQuadrantDataToPayload = (
  markedTeeth,
  quadrants,
  projectId,
  caseId
) => {
  // Transform teeth section
  const transformedTeeth = markedTeeth
    .filter((markTeeth) => markTeeth.tooth_id !== "")
    .map((tooth) => {
      return {
        id: tooth?.tooth_id, // Assuming tooth_id is the unique ID
        conditions: tooth.subConditions,
        observation: tooth.observation,
      };
    });

  // Transform quadrants section
  const transformedQuadrants = quadrants
    .filter((quadrant) => quadrant.quadrant !== "") // Filter out quadrants with an empty identifier
    .map((quadrant) => {
      return {
        quadrant: quadrant.identifier, // Quadrant identifier (ul, ur, ll, lr)
        conditions: quadrant.subConditions.map((condition) => condition), // Condition IDs
        observation: quadrant.observation,
      };
    });

  // Build final payload
  const payload = {
    project_id: Number(projectId),
    case_id: Number(caseId),
    teeth: transformedTeeth,
    quadrants: transformedQuadrants,
  };

  return payload;
};

export const isAllTeethMarkedCompleted = (markedTeeth) => {
  // Check if any tooth_id is empty or marked_completed is false
  return !markedTeeth.some(
    (tooth) => !tooth.tooth_id || !tooth.marked_completed
  );
};
export const isAtLeastOneTeethMarkedCompleted = (markedTeeth) => {
  return markedTeeth.some((tooth) => tooth.tooth_id && tooth.marked_completed);
};

export const sortSurfacesOnToothTypeBase = (
  toothType,
  surfaces,
  toothQuadrantIndex
) => {
  // index 0 is upper right
  // index 1 is upper left
  // index 2 is lower right
  // index 3 is lower left

  // molar
  const uperRightMolarOrder = [
    "Cusp (DB)",
    "Buccal",
    "Cusp (MB)",
    "Distal",
    "Occlusal",
    "Mesial",
    "Cusp (DP)",
    "Palatal",
    "Cusp (MP)",
  ];
  const upperLeftMolarOrder = [
    "Cusp (MB)",
    "Buccal",
    "Cusp (DB)",
    "Mesial",
    "Occlusal",
    "Distal",
    "Cusp (MP)",
    "Palatal",
    "Cusp (DP)",
  ];
  const lowerRightMolarOrder = [
    "Cusp (DL)",
    "Lingual",
    "Cusp (ML)",
    "Distal",
    "Occlusal",
    "Mesial",
    "Cusp (DB)",
    "Buccal",
    "Cusp (MB)",
  ];

  const lowerLeftMolarOrder = [
    "Cusp (ML)",
    "Lingual",
    "Cusp (DL)",
    "Mesial",
    "Occlusal",
    "Distal",
    "Cusp (MB)",
    "Buccal",
    "Cusp (DB)",
  ];

  // pre molar
  const uperRightPremolarOrder = [
    "Cusp (BC)",
    "Distal",
    "Occlusal",
    "Mesial",
    "Cusp (PC)",
  ];
  const uperLeftPremolarOrder = [
    "Cusp (BC)",
    "Mesial",
    "Occlusal",
    "Distal",
    "Cusp (PC)",
  ];
  const lowerRightPremolarOrder = [
    "Cusp (LC)",
    "Distal",
    "Occlusal",
    "Mesial",
    "Cusp (BC)",
  ];
  const lowerLeftPremolarOrder = [
    "Cusp (LC)",
    "Mesial",
    "Occlusal",
    "Distal",
    "Cusp (BC)",
  ];

  // incisors

  const upperAndLowerRightIncisors = ["Distal", "Incisal", "Mesial"];
  const upperAndLowerLeftIncisors = ["Mesial", "Incisal", "Distal"];

  // Sorting function
  const sortManually = (array, order) => {
    return array.sort((a, b) => {
      const indexA = order.indexOf(a.title);
      const indexB = order.indexOf(b.title);
      return indexA - indexB;
    });
  };

  // Check tooth type and sort accordingly
  if (toothType === "upper_molar" && toothQuadrantIndex === 0) {
    return sortManually(surfaces, uperRightMolarOrder);
  } else if (toothType === "upper_molar" && toothQuadrantIndex === 1) {
    return sortManually(surfaces, upperLeftMolarOrder);
  } else if (toothType === "lower_molar" && toothQuadrantIndex === 2) {
    return sortManually(surfaces, lowerRightMolarOrder);
  } else if (toothType === "lower_molar" && toothQuadrantIndex === 3) {
    return sortManually(surfaces, lowerLeftMolarOrder);
  } else if (toothType === "upper_premolar" && toothQuadrantIndex === 0) {
    return sortManually(surfaces, uperRightPremolarOrder);
  } else if (toothType === "upper_premolar" && toothQuadrantIndex === 1) {
    return sortManually(surfaces, uperLeftPremolarOrder);
  } else if (toothType === "lower_premolar" && toothQuadrantIndex === 2) {
    return sortManually(surfaces, lowerRightPremolarOrder);
  } else if (toothType === "lower_premolar" && toothQuadrantIndex === 3) {
    return sortManually(surfaces, lowerLeftPremolarOrder);
  } else if (
    (toothType === "upper_central" ||
      toothType === "upper_lateral" ||
      toothType === "lower_central" ||
      toothType === "lower_lateral") &&
    (toothQuadrantIndex === 0 || toothQuadrantIndex === 2)
  ) {
    return sortManually(surfaces, upperAndLowerRightIncisors);
  } else if (
    (toothType === "upper_central" ||
      toothType === "upper_lateral" ||
      toothType === "lower_central" ||
      toothType === "lower_lateral") &&
    (toothQuadrantIndex === 1 || toothQuadrantIndex === 3)
  ) {
    return sortManually(surfaces, upperAndLowerLeftIncisors);
  }

  // Return surfaces as is if the condition doesn't match
  return surfaces;
};

export const getFormattedAge = (record) => {
  const convertDecimalAge = (decimalAge) => {
    const years = Math.floor(decimalAge);
    const months = Math.round((decimalAge - years) * 12);
    return { years, months };
  };

  if (record?.estimated_age_from && record?.estimated_age_to) {
    const from = convertDecimalAge(parseFloat(record.estimated_age_from));
    const to = convertDecimalAge(parseFloat(record.estimated_age_to));

    return `${from.years}y, ${from.months}m To ${to.years}y, ${to.months}m`;
  } else if (record?.estimated_age) {
    const { years, months } = convertDecimalAge(
      parseFloat(record.estimated_age)
    );
    return `${years}y, ${months}m`;
  } else if (record?.age_years) {
    return `${record.age_years}y`;
  } else if (record?.dob) {
    const dob = new Date(record.dob);
    const today = new Date();

    let years = today.getFullYear() - dob.getFullYear();
    let months = today.getMonth() - dob.getMonth();
    let days = today.getDate() - dob.getDate();

    if (months < 0 || (months === 0 && days < 0)) {
      years--;
      months += 12;
    }

    if (days < 0) {
      const prevMonth = new Date(today.getFullYear(), today.getMonth(), 0);
      days += prevMonth.getDate();
      months--;
    }

    if (years > 0) {
      return `${years}y${months > 0 ? `, ${months}m` : ""}`;
    } else if (months > 0) {
      return `${months}m${days > 0 ? `, ${days}d` : ""}`;
    } else {
      return `${days}d`;
    }
  }

  return "N/A";
};

// export const getFormattedAge = (record) => {
//   if (record?.estimated_age_from && record?.estimated_age_to) {
//     const fromAge = record.estimated_age_from.split(".");
//     const toAge = record.estimated_age_to.split(".");

//     const fromYears = parseInt(fromAge[0], 10);
//     const fromMonths = parseInt(fromAge[1], 10);

//     const toYears = parseInt(toAge[0], 10);
//     const toMonths = parseInt(toAge[1], 10);

//     return `${fromYears}y, ${fromMonths}m To ${toYears}y, ${toMonths}m`;
//   } else if (record?.estimated_age) {
//     return `${record.estimated_age},y`; // Directly return estimated age
//   } else if (record?.age_years) {
//     return `${record.age_years},y`; // Append "Y" to age_years
//   } else if (record?.dob) {
//     const dob = new Date(record.dob);
//     const today = new Date();

//     let years = today.getFullYear() - dob.getFullYear();
//     let months = today.getMonth() - dob.getMonth();
//     let days = today.getDate() - dob.getDate();

//     // Adjust for negative month difference
//     if (months < 0 || (months === 0 && days < 0)) {
//       years--;
//       months += 12;
//     }

//     // Adjust for negative day difference
//     if (days < 0) {
//       const prevMonth = new Date(today.getFullYear(), today.getMonth(), 0);
//       days += prevMonth.getDate();
//       months--;
//     }

//     // Return formatted string
//     if (years > 0) {
//       return `${years}y,${months > 0 ? ` ${months}m` : ""}`; // Show months only if nonzero
//     } else if (months > 0) {
//       return `${months}y,${days > 0 ? ` ${days}d` : ""}`;
//     } else {
//       return `${days}d`; // Show only days if < 1 month
//     }
//   }

//   return "N/A"; // Default fallback
// };

// export const getFormattedAge = (record) => {
//   if (record?.estimated_age_from && record?.estimated_age_to) {
//     const fromAge = record.estimated_age_from.split(".");
//     const toAge = record.estimated_age_to.split(".");

//     const fromYears = parseInt(fromAge[0], 10);
//     const fromMonths = fromAge[1] ? parseInt(fromAge[1], 10) : 0; // Default to 0 if month is undefined

//     const toYears = parseInt(toAge[0], 10);
//     const toMonths = toAge[1] ? parseInt(toAge[1], 10) : 0; // Default to 0 if month is undefined

//     return `${fromYears}y, ${fromMonths}m To ${toYears}y, ${toMonths}m`;
//   } else if (record?.estimated_age) {
//     return `${record.estimated_age},y`; // Directly return estimated age
//   } else if (record?.age_years) {
//     return `${record.age_years},y`; // Append "Y" to age_years
//   } else if (record?.dob) {
//     const dob = new Date(record.dob);
//     const today = new Date();

//     let years = today.getFullYear() - dob.getFullYear();
//     let months = today.getMonth() - dob.getMonth();
//     let days = today.getDate() - dob.getDate();

//     // Adjust for negative month difference
//     if (months < 0 || (months === 0 && days < 0)) {
//       years--;
//       months += 12;
//     }

//     // Adjust for negative day difference
//     if (days < 0) {
//       const prevMonth = new Date(today.getFullYear(), today.getMonth(), 0);
//       days += prevMonth.getDate();
//       months--;
//     }

//     // Return formatted string
//     if (years > 0) {
//       return `${years}y,${months > 0 ? ` ${months}m` : ""}`; // Show months only if nonzero
//     } else if (months > 0) {
//       return `${months}y,${days > 0 ? ` ${days}d` : ""}`;
//     } else {
//       return `${days}d`; // Show only days if < 1 month
//     }
//   }

//   return "N/A"; // Default fallback
// };

export const columnColors = {
  1: "#ffebcc", // 1st column
  2: "#e0f7fa", // 2nd column
  3: "#fce4ec", // 3rd column
};

export const renderQuadrantTitle = (q) => {
  const titles = {
    ur: "Upper Right Quadrant (1)",
    ul: "Upper Left  Quadrant (2)",
    lr: "Lower Right Quadrant (4)",
    ll: "Lower Left Quadrant (3)",
  };

  return titles[q] || "Unknown Quadrant";
};

export const cameriereTeethList = [
  // Upper Right Quadrant
  {
    fdi: "11",
    toothName: "Upper Right Central",
    displayName: "Central – Upper Right – 11",
    quadrant: "Upper Right Quadrant",
  },
  {
    fdi: "12",
    toothName: "Upper Right Lateral",
    displayName: "Lateral – Upper Right – 12",
    quadrant: "Upper Right Quadrant",
  },
  {
    fdi: "13",
    toothName: "Upper Right Canine",
    displayName: "Canine – Upper Right – 13",
    quadrant: "Upper Right Quadrant",
  },
  {
    fdi: "14",
    toothName: "Upper Right 1st Premolar",
    displayName: "Premolar 1st – Upper Right – 14",
    quadrant: "Upper Right Quadrant",
  },
  {
    fdi: "15",
    toothName: "Upper Right 2nd Premolar",
    displayName: "Premolar 2nd – Upper Right – 15",
    quadrant: "Upper Right Quadrant",
  },
  {
    fdi: "16",
    toothName: "Upper Right 1st Molar",
    displayName: "Molar 1st – Upper Right – 16",
    quadrant: "Upper Right Quadrant",
  },
  {
    fdi: "17",
    toothName: "Upper Right 2nd Molar",
    displayName: "Molar 2nd – Upper Right – 17",
    quadrant: "Upper Right Quadrant",
  },
  {
    fdi: "18",
    toothName: "Upper Right 3rd Molar",
    displayName: "Molar 3rd – Upper Right – 18",
    quadrant: "Upper Right Quadrant",
  },

  // Upper Left Quadrant
  {
    fdi: "21",
    toothName: "Upper Left Central",
    displayName: "Central – Upper Left – 21",
    quadrant: "Upper Left Quadrant",
  },
  {
    fdi: "22",
    toothName: "Upper Left Lateral",
    displayName: "Lateral – Upper Left – 22",
    quadrant: "Upper Left Quadrant",
  },
  {
    fdi: "23",
    toothName: "Upper Left Canine",
    displayName: "Canine – Upper Left – 23",
    quadrant: "Upper Left Quadrant",
  },
  {
    fdi: "24",
    toothName: "Upper Left 1st Premolar",
    displayName: "Premolar 1st – Upper Left – 24",
    quadrant: "Upper Left Quadrant",
  },
  {
    fdi: "25",
    toothName: "Upper Left 2nd Premolar",
    displayName: "Premolar 2nd – Upper Left – 25",
    quadrant: "Upper Left Quadrant",
  },
  {
    fdi: "26",
    toothName: "Upper Left 1st Molar",
    displayName: "Molar 1st – Upper Left – 26",
    quadrant: "Upper Left Quadrant",
  },
  {
    fdi: "27",
    toothName: "Upper Left 2nd Molar",
    displayName: "Molar 2nd – Upper Left – 27",
    quadrant: "Upper Left Quadrant",
  },
  {
    fdi: "28",
    toothName: "Upper Left 3rd Molar",
    displayName: "Molar 3rd – Upper Left – 28",
    quadrant: "Upper Left Quadrant",
  },

  // Lower Left Quadrant
  {
    fdi: "31",
    toothName: "Lower Left Central",
    displayName: "Central – Lower Left – 31",
    quadrant: "Lower Left Quadrant",
  },
  {
    fdi: "32",
    toothName: "Lower Left Lateral",
    displayName: "Lateral – Lower Left – 32",
    quadrant: "Lower Left Quadrant",
  },
  {
    fdi: "33",
    toothName: "Lower Left Canine",
    displayName: "Canine – Lower Left – 33",
    quadrant: "Lower Left Quadrant",
  },
  {
    fdi: "34",
    toothName: "Lower Left 1st Premolar",
    displayName: "Premolar 1st – Lower Left – 34",
    quadrant: "Lower Left Quadrant",
  },
  {
    fdi: "35",
    toothName: "Lower Left 2nd Premolar",
    displayName: "Premolar 2nd – Lower Left – 35",
    quadrant: "Lower Left Quadrant",
  },
  {
    fdi: "36",
    toothName: "Lower Left 1st Molar",
    displayName: "Molar 1st – Lower Left – 36",
    quadrant: "Lower Left Quadrant",
  },
  {
    fdi: "37",
    toothName: "Lower Left 2nd Molar",
    displayName: "Molar 2nd – Lower Left – 37",
    quadrant: "Lower Left Quadrant",
  },
  {
    fdi: "38",
    toothName: "Lower Left 3rd Molar",
    displayName: "Molar 3rd – Lower Left – 38",
    quadrant: "Lower Left Quadrant",
  },

  // Lower Right Quadrant
  {
    fdi: "41",
    toothName: "Lower Right Central",
    displayName: "Central – Lower Right – 41",
    quadrant: "Lower Right Quadrant",
  },
  {
    fdi: "42",
    toothName: "Lower Right Lateral",
    displayName: "Lateral – Lower Right – 42",
    quadrant: "Lower Right Quadrant",
  },
  {
    fdi: "43",
    toothName: "Lower Right Canine",
    displayName: "Canine – Lower Right – 43",
    quadrant: "Lower Right Quadrant",
  },
  {
    fdi: "44",
    toothName: "Lower Right 1st Premolar",
    displayName: "Premolar 1st – Lower Right – 44",
    quadrant: "Lower Right Quadrant",
  },
  {
    fdi: "45",
    toothName: "Lower Right 2nd Premolar",
    displayName: "Premolar 2nd – Lower Right – 45",
    quadrant: "Lower Right Quadrant",
  },
  {
    fdi: "46",
    toothName: "Lower Right 1st Molar",
    displayName: "Molar 1st – Lower Right – 46",
    quadrant: "Lower Right Quadrant",
  },
  {
    fdi: "47",
    toothName: "Lower Right 2nd Molar",
    displayName: "Molar 2nd – Lower Right – 47",
    quadrant: "Lower Right Quadrant",
  },
  {
    fdi: "48",
    toothName: "Lower Right 3rd Molar",
    displayName: "Molar 3rd – Lower Right – 48",
    quadrant: "Lower Right Quadrant",
  },
];

const toothPriority = (fdi) => {
  switch (parseInt(fdi, 10)) {
    case 36:
    case 37:
    case 46:
    case 47:
      return 1; // Lower Molar
    case 15:
    case 25:
      return 2; // Upper 2nd Premolar
    case 45:
    case 35:
      return 3; // Lower 2nd Premolar
    case 12:
    case 22:
      return 4; // Upper Lateral
    case 11:
    case 21:
      return 5; // Upper Central
    case 13:
    case 23:
      return 6; // Upper Canine
    case 44:
    case 34:
      return 7; // Lower 1st Premolar
    case 31:
    case 41:
      return 8; // Lower Central
    case 32:
    case 42:
      return 9; // Lower Lateral
    case 33:
    case 43:
      return 10; // Lower Canine
    default:
      return 99;
  }
};

export const buildInterpretation = (teethResults) => {
  if (!teethResults || teethResults.length === 0) return "";

  const enriched = teethResults.map((item) => {
    const { confidence } = getToothConfidence(
      item.fdi,
      item.dental_age_numeric
    );
    return {
      ...item,
      confidence,
      priority: toothPriority(item.fdi),
      toothName:
        cameriereTeethList.find((t) => t.fdi == item.fdi)?.toothName ||
        "Unknown Tooth",
    };
  });

  // Step 1: group by priority
  enriched.sort((a, b) => a.priority - b.priority);

  // Step 2: get all with the best (lowest) priority
  const topPriority = enriched[0].priority;
  const samePriorityTeeth = enriched.filter((t) => t.priority === topPriority);

  // Step 3: pick highest confidence inside this priority group
  samePriorityTeeth.sort((a, b) => b.confidence - a.confidence);
  const best = samePriorityTeeth[0];

  const totalTeeth = enriched.length;

  return `Based on the analysis of ${totalTeeth} teeth, the subject’s estimated dental age is ${best.dental_age}, consistent with the ${best.toothName}, which showed the higher confidence score (${best.confidence}%).`;
};

export const getToothConfidence = (fdi, age) => {
  let lower = null;
  let upper = null;
  fdi = parseInt(fdi, 10); // ensure number
  switch (fdi) {
    // Lower Molar (36,37,46,47)
    case 36:
    case 37:
    case 46:
    case 47:
      lower = 18.43;
      upper = 32.02;
      break;

    // Upper 2nd Premolar (15,25)
    case 15:
    case 25:
      lower = 25.23;
      upper = 38.81;
      break;

    // Lower 2nd Premolar (45,35)
    case 45:
    case 35:
      lower = 32.02;
      upper = 45.6;
      break;

    // Upper Lateral (12,22)
    case 12:
    case 22:
      lower = 38.81;
      upper = 52.39;
      break;

    // Upper Central (11,21)
    case 11:
    case 21:
      lower = 38.81;
      upper = 52.39;
      break;

    // Upper Canine (13,23)
    case 13:
    case 23:
      lower = 45.6;
      upper = 59.18;
      break;

    // Lower 1st Premolar (44,34)
    case 44:
    case 34:
      lower = 52.39;
      upper = 65.97;
      break;

    // Lower Central (31,41)
    case 31:
    case 41:
      lower = 59.18;
      upper = 72.76;
      break;

    // Lower Lateral (32,42)
    case 32:
    case 42:
      lower = 59.18;
      upper = 72.76;
      break;

    // Lower Canine (33,43)
    case 33:
    case 43:
      lower = 65.98;
      upper = 79.56;
      break;

    default:
      return 0; // unknown tooth
  }

  // If no age provided, return minimum confidence
  if (!age && age !== 0) return 0;

  // Midpoint of the range
  const mid = (lower + upper) / 2;
  const halfRange = (upper - lower) / 2;

  // Formula: clamp between 10 and 90
  let confidence = 100 - (Math.abs(age - mid) / halfRange) * 100;
  confidence = Math.max(10, Math.min(90, confidence));

  confidence = Math.round(confidence); // round nicely

  // Interpretation
  let interpretation = "";
  if (confidence >= 85) {
    interpretation = "High confidence";
  } else if (confidence >= 60) {
    interpretation = "Moderate confidence";
  } else {
    interpretation = "Low confidence";
  }

  return { confidence, interpretation };
};

export const showInformationOfConditionType = (type) => {
  const mapedConditionType = {
    "M-I": "Implant Placed",
    "M-B": "Bridge Placed",
    "M-L": "Tooth Loss",
    "R-F": "Crown Filling",
    "R-C": "Dental Crown",
    "R-R": "Restored Root",
    "P-M": "Tooth Morphology",
    "P-I": "Intact Variant",
    "P-P": "Pathology Present",
    "L-B": "Bone Condition",
    "L-O": "Occlusal Variations",
    "L-C": "Cyst Lesions",
  };
  return mapedConditionType[type];
};

export const prepareFormData = ({
  teethChart,
  subject,
  opgImage,
  radiographs,
}) => {
  const formData = new FormData();

  // Convert teethChart data into categorized arrays
  const categorizedTeeth = {
    missing_teeth: [],
    restored_teeth: [],
    decayed_teeth: [],
    present_teeth: [],
  };

  // Populate categorizedTeeth dynamically based on teethChart data
  teethChart.forEach(({ tooth_id, condition_type }) => {
    const key = `${condition_type}_teeth`; // Directly form the key
    if (categorizedTeeth.hasOwnProperty(key)) {
      categorizedTeeth[key].push(String(tooth_id));
    }
  });

  // Append categorized teeth data
  Object.entries(categorizedTeeth).forEach(([key, value]) => {
    formData.append(key, JSON.stringify(value));
  });

  // Append subject data dynamically
  Object.entries(subject).forEach(([key, value]) => {
    if (value !== "" && value !== null) {
      if (key === "radiograph_date") {
        const formattedDate = moment(value).format("YYYY-MM-DD"); // Convert to Y-m-d format
        formData.append(key, formattedDate);
      } else if (key === "reported_dob") {
        const formattedDob = moment(value).format("YYYY-MM-DD"); // Convert to Y-m-d format
        formData.append(key, formattedDob);
      } else {
        formData.append(key, value);
      }
    }
  });

  // Append image files (use the actual file, not the preview URL)
  if (opgImage?.file) {
    formData.append("opg", opgImage.file);
  }

  if (Array.isArray(radiographs)) {
    radiographs.forEach(({ file }) => {
      if (file) {
        formData.append("additional_images[]", file);
      }
    });
  }

  return formData;
};

export const johansonGustafsonFormFieldsCombinations = [
  { id: 11, name: "ASPTCR", type: "tooth" },
  { id: 12, name: "APTCR", type: "tooth" },
  { id: 13, name: "APTR", type: "tooth" },
  { id: 14, name: "APT", type: "tooth" },
  { id: 15, name: "AT", type: "tooth" },
  { id: 21, name: "PTCR", type: "root" },
  { id: 22, name: "PTR", type: "root" },
  { id: 23, name: "TCR", type: "root" },
  { id: 24, name: "PT", type: "root" },
  { id: 25, name: "TR", type: "root" },
  { id: 26, name: "T", type: "root" },
];

export const johansonGustafsonFormFieldsMapping = {
  A: { name: "attrition_A", label: "Attrition of Enamel (A)" },
  S: { name: "secondary_dentin_S", label: "Secondary Dentine (S)" },
  P: { name: "paradentosis_P", label: "Periodontal Recession (P)" },
  T: { name: "root_transparency_T", label: "Translucency of Root (T)" },
  C: { name: "cementum_C", label: "Cementum Apposition (C)" },
  R: { name: "root_resorption_R", label: "Root Resorption (R)" },
};

export const maplesFormFieldsCombinations = [
  { id: 1000, name: "ASPTC", type: "tooth" },
  { id: 1001, name: "ST", type: "tooth_st" },
  { id: 26, name: "T", type: "root" },
];
export const collationFormFieldsCombinations = [
  { id: 11, name: "ASPTCR", type: "tooth" },
  { id: 26, name: "T", type: "root" },
];

export const getCustomTitleForGuidlineField = (infoType) => {
  const titles = {
    attrition_A: "Dental Attrition (A)",
    secondary_dentin_S: "Secondary Dentin (S)",
    paradentosis_P: "Peraiodontal Regression (P)",
    root_transparency_T: "Root Transparency (T)",
    cementum_C: "Cementum Apposition (C)",
    root_resorption_R: "Root Resorption (R)",
  };

  return titles[infoType] || "Unknown"; // Default title if infoType is not found
};

export const parseStageDescription = (description) => {
  if (!description) {
    return { title: "No Title", description: "No description available" };
  }

  const [title, ...descParts] = description.split(":");
  return {
    title: title.trim(),
    description: descParts.join(":").trim(), // Join back in case of additional colons
  };
};

export const getDentalAge = (index, data) => {
  const collaborator = data?.collaborators[index];
  let age = collaborator.age;

  if (collaborator.selectedAge === "upper_limit") {
    age = collaborator.upperLimit;
  } else if (collaborator.selectedAge === "lower_limit") {
    age = collaborator.lowerLimit;
  }

  return convertToProperFormat(age.toString());
};

function convertToProperFormat(value) {
  let ageYears = 0;
  let ageMonths = 0.0;

  if (value.includes(".")) {
    const parts = value.split(".");
    ageYears = parseInt(parts[0], 10);
    ageMonths = parseFloat("0." + parts[1]);
  } else {
    ageYears = parseInt(value, 10);
    ageMonths = 0.0;
  }

  let finalYearsFormat = "";
  let finalMonthsFormat = "";

  if (ageYears !== 0) {
    finalYearsFormat = `${ageYears}y`;
  }

  if (ageMonths !== 0.0) {
    const monthData = Math.floor(ageMonths * 12);
    if (monthData > 0) {
      finalMonthsFormat = `${monthData}m`;
    }
  }

  if (finalYearsFormat && !finalMonthsFormat) {
    return finalYearsFormat;
  }

  if (!finalYearsFormat && finalMonthsFormat) {
    return finalMonthsFormat;
  }

  if (finalYearsFormat && finalMonthsFormat) {
    return `${finalYearsFormat}, ${finalMonthsFormat}`;
  }

  return "0";
}

export const toothObservation = [
  { id: 1, title: "Restored Tooth: stops root transparency." },
  { id: 2, title: "Close Bite: increases attrition in anterior teeth." },
  { id: 3, title: "Ortho-Treated Tooth: increases root resorption." },
  { id: 4, title: "Object Biting: increases localized tooth attrition." },
  { id: 5, title: "Cavity/Decayed Tooth: increases reparative dentine." },
  { id: 6, title: "Open Bite: decreases natural attrition in anterior teeth." },
  {
    id: 7,
    title: "Loose/Exposed Root: increases periodontal attachment loss.",
  },
  {
    id: 8,
    title: "Trauma Tooth: alters the morphology and structure of the tooth.",
  },
  {
    id: 9,
    title:
      "Bruxism: excessive attrition that is not a natural aspect of aging.",
  },
];

export const referringAgency = [
  { id: 1, title: "Police and forensic departments" },
  { id: 2, title: "Authorities for Identity & Citizenship" },
  { id: 3, title: "Adoption centers and migration agencies" },
  { id: 4, title: "Embassies and foreign affairs departments" },
  { id: 5, title: "Legal departments within the court system" },
  { id: 6, title: "Departments of hospitals and health services" },
];
export const purposeOfAssessmentInfo = [
  { id: 1, title: "Research and Development" },
  { id: 2, title: "Retirement / Work permits / Visas" },
  { id: 3, title: "Competency / Heritage-related matters" },
  { id: 4, title: "Document Verification / Financial loans" },
  { id: 5, title: "Child Recruitment / Trafficking / Adoption" },
  { id: 6, title: "Human Rights / Asylum Seeker / Criminal Liability" },
  {
    id: 7,
    title: "Human Identification / Player Category / Medical Intervention",
  },
];
export const medicalHisotryInfo = [
  {
    id: 1,
    title: "Smoking: increases gum disease and affects tooth structure.",
  },
  {
    id: 2,
    title: "Chronic Illness: Diabetes affects oral health and tooth structure.",
  },
  {
    id: 3,
    title: "Genetics: influences tooth development and causes abnormality.",
  },
  {
    id: 4,
    title: "Developmental Diseases: disrupt tooth development and structure.",
  },
  {
    id: 5,
    title:
      "Environment: impacts tooth structure such as toxins or acidic foods.",
  },
  {
    id: 6,
    title:
      "Hormonal Changes: puberty, pregnancy, and menopause affect oral health.",
  },
  {
    id: 7,
    title:
      "Diet and Nutrition: lack of nutrients or high sugar intake affects oral health.",
  },
  {
    id: 8,
    title:
      "Medications: certain meds cause alterations in the gum tissue and tooth structure.",
  },
];

export const boneAndDentalHealthInfo = [
  {
    id: 1,
    title:
      "Fluorosis from excessive fluoride intake leads to tooth structure abnormalities.",
  },
  {
    id: 2,
    title:
      "Osteoporosis, Osteomalacia, and Paget's disease can affect bone and teeth health.",
  },
  {
    id: 3,
    title:
      "Amelogenesis and Dentinogenesis Imperfecta lead to structurally abnormal teeth.",
  },
  {
    id: 4,
    title:
      "Radiation and chemotherapy impact oral health, leading to tooth structural issues.",
  },
  {
    id: 5,
    title:
      "Bisphosphonates for osteoporosis can cause osteonecrosis, affecting tooth structure.",
  },
  {
    id: 6,
    title:
      "Hypodontia is characterized by fewer teeth than usual, affecting the dental structure.",
  },
  {
    id: 7,
    title:
      "Antihypertensives (calcium blockers) cause gum hyperplasia and impact tooth structure.",
  },
  {
    id: 8,
    title:
      "Antiseizure drugs (phenytoin) cause gingival overgrowth and structural changes in teeth.",
  },
  {
    id: 9,
    title:
      "Celiac Disease, an autoimmune disorder, disrupts tooth development and causes defects.",
  },
];

export const renderSubscriptionStatusTextAndBgColor = (status) => {
  const statusObject = {
    textColor: "",
    bgColor: "",
    status: "",
  };

  switch (status) {
    case "active":
      statusObject.textColor = "#00AA55"; // Green
      statusObject.bgColor = "#E5F7EE";
      statusObject.status = "Active";
      break;

    case "inActive":
      statusObject.textColor = "#5C5858"; // Red
      statusObject.bgColor = "#F3F3F3";
      statusObject.status = "Inactive";
      break;
    case "pending":
      statusObject.textColor = "#FD9647"; // Red
      statusObject.bgColor = "#FFF4ED";
      statusObject.status = "Pending";

      break;
    case "expired":
      statusObject.textColor = "#D52B1E"; // Red
      statusObject.bgColor = "#D52B1E1A";
      statusObject.status = "Expired";

      break;
    case "cancelled":
      statusObject.textColor = "#D52B1E"; // Red
      statusObject.bgColor = "#D52B1E1A";
      statusObject.status = "Expired";

      break;

    default:
      statusObject.textColor = ""; // Default dark gray
      statusObject.bgColor = "";
      statusObject.status = "";
      break;
  }

  return statusObject;
};

export const isAdminLogin = (examinars, id) => {
  const examinar = examinars.find((examinar) => examinar.id === id);
  return examinar?.role === "admin";
};

export const getDecimalAge = (year, month) => {
  const y = parseInt(year) || 0;
  const m = parseInt(month) || 0;
  return parseFloat((y + m / 12).toFixed(2));
};

// export const getAgeValidationTag = (am_case, pm_case) => {
//   const statedAge = parseInt(am_case?.stated_age);
//   const ageFrom = parseInt(pm_case?.estimated_age_from);
//   const ageTo = parseInt(pm_case?.estimated_age_to);

//   if (
//     !isNaN(statedAge) &&
//     !isNaN(ageFrom) &&
//     !isNaN(ageTo) &&
//     statedAge >= ageFrom &&
//     statedAge <= ageTo
//   ) {
//     return <span className="validated-tag">Age Validated</span>;
//   }

//   return null;
// };

export const getAgeValidationTag = (am_case, pm_case) => {
  let statedAge = parseFloat(am_case?.age_years);
  // console.log("Stated Age:", statedAge);
  // console.log("am_case?.dob", am_case?.dob);

  if (am_case?.age_years === "" || statedAge === 0 || isNaN(statedAge)) {
    if (am_case?.dob && am_case.dob.trim() !== "") {
      statedAge = calculateDecimalAge(am_case.dob);
      // console.log("Calculated statedAge from DOB:", statedAge);
    }
  }

  // Fallback if statedAge still invalid
  if (isNaN(statedAge) && am_case?.dob) {
    statedAge = calculateDecimalAge(am_case.dob);
    // console.log("Fallback statedAge from DOB:", statedAge);
  }

  const ageFrom = parseFloat(pm_case?.estimated_age_from);
  const ageTo = parseFloat(pm_case?.estimated_age_to);

  // console.log("Stated Age:", statedAge);
  // console.log("Age From:", ageFrom);
  // console.log("Age To:", ageTo);

  if (
    !isNaN(statedAge) &&
    !isNaN(ageFrom) &&
    !isNaN(ageTo) &&
    statedAge >= ageFrom &&
    statedAge <= ageTo
  ) {
    return <ValidatedAge />;
  }

  return null;
};

const calculateDecimalAge = (dobStr) => {
  const dob = new Date(dobStr);
  const today = new Date();
  const diffInMilliseconds = today - dob;
  const ageInYears = diffInMilliseconds / (365.25 * 24 * 60 * 60 * 1000); // accounts for leap years
  return parseFloat(ageInYears.toFixed(2)); // round to 2 decimal places
};

export const getMyInfoFromProjectCollaborators = (collaborators, userId) => {
  if (!Array.isArray(collaborators) || collaborators.length === 0) return null;

  const user = collaborators.find((collaborator) => collaborator.id === userId);
  return user || null;
};

export const getProjectCode = (id) => {
  if (typeof id !== "number") id = parseInt(id);
  return `P${id.toString().padStart(3, "0")}`;
};

export const identityStatusConfig = {
  "Identity Established": {
    short: "High-confidence match. No mismatches detected.",
    details: [
      "Automated assessment indicates the AM and PM records pertain to the same individual.",
      "Rule satisfied: match ratio ≥ 85% and mismatches = 0.",
    ],
    actions: [
      "Finalize the identification in the case record.",
      "Attach corroborating evidence as required by protocol.",
    ],
    // UI Properties
    ui: {
      icon: <CheckCircleOutlined />,
      color: "#52c41a", // Ant Design Success Green
      tagColor: "success",
    },
  },
  "Identity Possible": {
    short: "Probable match. Review recommended.",
    details: [
      "Strong correspondence with permissible progression in several teeth.",
      "Rule satisfied: match ratio 60–84%, ≤ 2 mismatches, and ≥ 3 possible matches.",
    ],
    actions: [
      "Review teeth marked as possible matches for progression consistency.",
      "Seek secondary confirmation (e.g., medical history, DNA, fingerprints).",
    ],
    // UI Properties
    ui: {
      icon: <ExclamationCircleOutlined />,
      color: "#faad14", // Ant Design Warning Yellow
      tagColor: "warning",
    },
  },
  "Review Suggested": {
    short: "Inconclusive. Targeted review required.",
    details: [
      "Either a high match ratio with a limited mismatch, or a moderate match with multiple mismatches.",
      "Rules covered: (a) ≥ 85% with exactly 1 mismatch, or (b) 60–84% with 3–5 mismatches and ≥ 1 possible match.",
    ],
    actions: [
      "Re-examine mismatched teeth and verify AM/PM annotations.",
      "Request a secondary examiner review if available.",
    ],
    // UI Properties
    ui: {
      icon: <SearchOutlined />,
      color: "#fa8c16", // Ant Design Orange
      tagColor: "orange",
    },
  },
  "Identity Excluded": {
    short: "Evidence supports exclusion.",
    details: [
      "Low match ratio with numerous mismatches and no plausible progressions.",
      "Rule satisfied: match ratio < 60%, mismatches > 5, and possible matches = 0.",
    ],
    actions: [
      "Record exclusion and continue evaluating alternative candidates.",
      "Document the basis for exclusion in the case notes.",
    ],
    // UI Properties
    ui: {
      icon: <CloseCircleOutlined />,
      color: "#f5222d", // Ant Design Error Red
      tagColor: "error",
    },
  },
  "Manual Review": {
    short: "Automated decision not possible.",
    details: [
      "Insufficient evaluable teeth or conflicting indicators for automated classification.",
      "Examples: evaluable teeth < 10; high match with ≥ 2 mismatches; 60–84% with zero possible & zero mismatches.",
    ],
    actions: [
      "Improve evaluable count if feasible; validate image quality and annotations.",
      "Conduct a full manual forensic review before concluding.",
    ],
    // UI Properties
    ui: {
      icon: <QuestionCircleOutlined />,
      color: "rgba(0, 0, 0, 0.45)", // Ant Design Default Grey
      tagColor: "default",
    },
  },
};

export const TEETH_SVGS_SIZE = {
  // Upper Right Quadrant (1X)
  18: { height: 50, width: 50 }, // Molar
  17: { height: 55, width: 48 }, // Molar
  16: { height: 60, width: 46 }, // Molar
  15: { height: 65, width: 38 }, // Premolar
  14: { height: 55, width: 36 }, // Premolar
  13: { height: 75, width: 34 }, // Canine
  12: { height: 50, width: 30 }, // Lateral Incisor
  11: { height: 50, width: 28 }, // Central Incisor

  // Upper Left Quadrant (2X)
  21: { height: 50, width: 50 },
  22: { height: 55, width: 48 },
  23: { height: 75, width: 34 },
  24: { height: 55, width: 38 },
  25: { height: 65, width: 36 },
  26: { height: 60, width: 46 },
  27: { height: 58, width: 48 },
  28: { height: 55, width: 50 },

  // Lower Left Quadrant (3X)
  31: { height: 70, width: 28 }, // Central Incisor
  32: { height: 69, width: 28 }, // Lateral Incisor
  33: { height: 67, width: 32 }, // Canine
  34: { height: 64, width: 36 }, // Premolar
  35: { height: 62, width: 38 }, // Premolar
  36: { height: 60, width: 46 }, // Molar
  37: { height: 58, width: 48 }, // Molar
  38: { height: 55, width: 50 }, // Molar

  // Lower Right Quadrant (4X)
  41: { height: 70, width: 28 },
  42: { height: 69, width: 28 },
  43: { height: 67, width: 32 },
  44: { height: 64, width: 36 },
  45: { height: 62, width: 38 },
  46: { height: 60, width: 46 },
  47: { height: 58, width: 48 },
  48: { height: 55, width: 50 },
};
export const _dummyAnalysisProject = [
  {
    id: 1,
    title: "Molar Analysis - Patient A",
    status: "Completed",
    date: "Aug 18, 2025",
    time: "11:56 AM",
    modifiedAt: "Modified Aug 18, 2025",
    modifiedTime: "11:56 AM",
  },
  {
    id: 2,
    title: "Molar Analysis - Patient A",
    status: "In-Progress",
    date: "Aug 18, 2025",
    time: "11:56 AM",
    modifiedAt: "Modified Aug 18, 2025",
    modifiedTime: "11:56 AM",
  },
  {
    id: 3,
    title: "Molar Analysis - Patient A",
    status: "Completed",
    date: "Aug 18, 2025",
    time: "11:56 AM",
    modifiedAt: "Modified Aug 18, 2025",
    modifiedTime: "11:56 AM",
  },
  {
    id: 4,
    title: "Molar Analysis - Patient A",
    status: "In-Progress",
    date: "Aug 18, 2025",
    time: "11:56 AM",
    modifiedAt: "Modified Aug 18, 2025",
    modifiedTime: "11:56 AM",
  },
  {
    id: 5,
    title: "Molar Analysis - Patient A",
    status: "In-Progress",
    date: "Aug 18, 2025",
    time: "11:56 AM",
    modifiedAt: "Modified Aug 18, 2025",
    modifiedTime: "11:56 AM",
  },
];

export const _teethOptions = [
  {
    id: 1,
    title: "Tooth",
    value: "tooth",
    badge: "Tooth",
    colorClass: "bg-[#0A9FD4]",
  },
  {
    id: 2,
    title: "Pulp",
    value: "pulp",
    badge: "Pulp",
    colorClass: "bg-[#10B981]",
  },
  {
    id: 3,
    title: "Root",
    value: "root",
    badge: "Root",
    colorClass: "bg-[#7C3AED]",
  },
  {
    id: 4,
    title: "Restoration",
    value: "restoration",
    badge: "Restoration",
    colorClass: "bg-[#F59E0B]",
  },
  {
    id: 5,
    title: "Radiolucent",
    value: "radiolucent",
    badge: "Radiolucent",
    colorClass: "bg-[#9A3412]",
  },
  {
    id: 6,
    title: "Pattern",
    value: "pattern",
    badge: "Pattern",
    colorClass: "bg-[#EF4444]",
  },
];
export const _measuremntOptions = [
  {
    id: 1,
    title: "Linear",
    value: "linear",
  },
  {
    id: 2,
    title: "Angle",
    value: "angle",
  },
  {
    id: 2,
    title: "Polygon",
    value: "polygon",
  },
];

// arr = your input array
// teethOptions (optional) = [{ fdi: "11", title: "Upper Right Central" }, ...]
export const transformSaveMeasurmentsForAgeEstimation = (
  arr,
  teethOptions = []
) => {
  const byFdi = new Map();
  const titleByFdi = new Map(teethOptions.map((t) => [String(t.fdi), t.title]));

  // Capture the area number and its unit from the "A: ..." part
  // e.g. "A: 87616.20 px (P: 575.93 px)" -> ["87616.20", "px"]
  const areaRe = /A:\s*([\d.]+)\s*([a-zA-Zμ²^2]*)/;

  for (const m of arr) {
    if (m.type !== "area") continue;

    const fdi = String(m.toothNumber);
    const label = String(m.label || "").toLowerCase(); // "tooth" | "pulp"
    const match = areaRe.exec(m.value || "");
    if (!match) continue;

    const area = parseFloat(match[1]);
    const unit = (match[2] || "px").trim(); // default to "px" if missing
    if (!Number.isFinite(area)) continue;

    if (!byFdi.has(fdi)) {
      byFdi.set(fdi, {
        toothName: titleByFdi.get(fdi) || "",
        fdi,
        pulpArea: 0,
        toothArea: 0,
        unit, // store area unit once per row
      });
    }

    const row = byFdi.get(fdi);
    // If a later entry has a unit, prefer a non-empty unit
    if (!row.unit && unit) row.unit = unit;

    if (label === "pulp") row.pulpArea = area;
    else if (label === "tooth") row.toothArea = area;
  }

  return Array.from(byFdi.values());
};

/* Example output:
[
  { toothName: "", fdi: "11", pulpArea: 77056.34, toothArea: 87616.2, unit: "px" },
  { toothName: "", fdi: "21", pulpArea: 23989.61, toothArea: 20627.28, unit: "px" }
]
*/
